import React, {useEffect} from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Modal } from 'react-bootstrap';
import ProfileEdit from '../admin/suppliers/profileEdit';
import LicenseCapture from '../admin/suppliers/licenseCapture';
import ResetPassword from '../admin/suppliers/resetPassword';
import { get_customer } from '../../redux/actions/adminActions';
import { connect } from 'react-redux';

function EditCustomerModal({ show, handleClose, user, getCustomer, customer, unapproved, accessToken}) {

    useEffect(() => {
        if(user){
            getCustomer(user.id, unapproved ? 'unapproved' : 'approved', accessToken)
        }
    }, [user])

    return (
        <Modal show={ show } onHide={ handleClose } centered>
            <div className="icon--tiny isClickable closeModal" onClick={ handleClose}>
                <i class="ri-close-line sectionText--small"></i>
            </div>
            <div className="suppliers">
                <Tabs>
                    <TabList className='alignOnly sectionText pl-0 p-2 mb-0'>
                        <Tab className='tabHead'>Profile</Tab>
                        <Tab className='tabHead'>Identity Verification</Tab>
                        <Tab className='tabHead'>Change Password</Tab>
                    </TabList>

                    <TabPanel>
                        <ProfileEdit user={customer} customer unapproved={unapproved}/>
                    </TabPanel>
                    <TabPanel>
                        <LicenseCapture user={ customer } customer unapproved={ unapproved }/>
                    </TabPanel>
                    <TabPanel>
                        <ResetPassword userId={ customer?.id} customer close={handleClose}/>
                    </TabPanel>
                </Tabs>
            </div>
        </Modal>
    )
}

const mapStateToProps = (state) => ({ customer: state.admin.customer,
accessToken: state.admin.token })

const mapDispatchToProps = (dispatch) => ({
    getCustomer: (id, status, token) => dispatch(get_customer(id, status, token))
})

export default connect(mapStateToProps, mapDispatchToProps)(EditCustomerModal)
